import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  yesActive: boolean;
  yesHandler: () => void;
  noHandler: () => void;
  dataTest?: string;
  disabled?: boolean;
};

export default function SecurityDepositCleaningCostYesAndNo({ dataTest, disabled, ...rest }: Props) {
  return (
    <FormField
      label={
        <Label>
          Can the security deposit be applied to cleaning costs incurred to return the property to the same level of
          cleanliness it was at the start date?
        </Label>
      }
      disabled={disabled ? disabled : false}
      control={<YesAndNo {...rest} disabled={disabled} data-test={dataTest} />}
    />
  );
}
